export default __webpack_public_path__ + "static/media/pt-img.6edfe14f.png";